module.exports = __webpack_public_path__ + "static/media/tiktokLogoSquare.1358797f.png";